import { useState, useEffect, useCallback } from 'react'
import { getStoredTheme, setStoredTheme, palette } from './theme'

/**
 * Hook: returns { mode, colors, toggle, setMode }.
 * Persists across reloads and broadcasts changes across tabs.
 */
export default function useNesterTheme() {
  const [mode, setModeState] = useState(() => getStoredTheme())

  useEffect(() => {
    function onStorage(e) {
      if (e.key === 'dxfNesterTheme' && (e.newValue === 'light' || e.newValue === 'dark')) {
        setModeState(e.newValue)
      }
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  const setMode = useCallback((next) => {
    setStoredTheme(next)
    setModeState(next)
  }, [])

  const toggle = useCallback(() => {
    setModeState(prev => {
      const next = prev === 'dark' ? 'light' : 'dark'
      setStoredTheme(next)
      return next
    })
  }, [])

  return { mode, colors: palette(mode), toggle, setMode }
}
